import React from "react";
import Loading from "../components/App/Loading";

const LogoutPage = () => <Loading />;

export default LogoutPage;
